import { useTranslation } from 'react-i18next';
import type { MediaAsset } from '@ghostscreen/contracts';
import { PlaylistAddMediaTile } from './PlaylistAddMediaTile';

type PlaylistDrawerAddMediaProps = {
  assets: MediaAsset[];
  busy: boolean;
  onAdd: (asset: MediaAsset) => void;
};

export function PlaylistDrawerAddMedia({ assets, busy, onAdd }: PlaylistDrawerAddMediaProps) {
  const { t } = useTranslation('playlists');
  if (assets.length === 0) {
    return (
      <p className="m-0 text-[13.5px]" style={{ color: 'var(--gs-muted)' }}>
        {t('addMedia.empty')}
      </p>
    );
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(min(100%,140px),1fr))] items-start gap-2.5">
      {assets.map((asset) => (
        <PlaylistAddMediaTile key={asset.id} asset={asset} busy={busy} onAdd={onAdd} />
      ))}
    </div>
  );
}
